// extracted by mini-css-extract-plugin
module.exports = {"Icon":"ScrollUp-module--Icon--1557T","Hidden":"ScrollUp-module--Hidden--1pP8I"};